import { useCallback, useEffect, RefObject } from 'react'

export const useDisableZoom = (
  isLoading: boolean,
  ref: RefObject<HTMLElement>
) => {
  // Function to disable zoom
  const disableZoom = useCallback(
    (e: WheelEvent | TouchEvent) => {
      if (isLoading) {
        e.preventDefault()
      }
    },
    [isLoading]
  )

  useEffect(() => {
    const element = ref.current
    if (element) {
      element.addEventListener('wheel', disableZoom, { passive: false })
      element.addEventListener('touchmove', disableZoom, { passive: false })

      return () => {
        element.removeEventListener('wheel', disableZoom)
        element.removeEventListener('touchmove', disableZoom)
      }
    }
  }, [isLoading, disableZoom, ref])
}
